import React from 'react';

/**
 * Tag — the ubiquitous tech-stack pill. "solid" is filled yellow,
 * "outline" is a hollow gold pill, "muted" is a soft raised chip.
 * Mono-flavoured by default.
 */
export function Tag({ children, variant = 'solid', size = 'md', ...rest }) {
  const sizes = {
    sm: { padding: '0.2rem 0.55rem', font: 'var(--text-2xs)' },
    md: { padding: '0.3rem 0.7rem', font: 'var(--text-xs)' },
  };
  const s = sizes[size] || sizes.md;

  const variants = {
    solid: { background: 'var(--accent)', color: 'var(--accent-contrast)', border: 'var(--border-hairline) solid transparent' },
    outline: { background: 'transparent', color: 'var(--text-accent)', border: 'var(--border-hairline) solid var(--yellow-a32)' },
    muted: { background: 'var(--bg-raised)', color: 'var(--text-secondary)', border: 'var(--border-hairline) solid var(--border-subtle)' },
  };

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: s.padding,
        fontFamily: 'var(--font-mono)',
        fontSize: s.font,
        fontWeight: 'var(--weight-medium)',
        letterSpacing: 'var(--tracking-wide)',
        lineHeight: 1.2,
        borderRadius: 'var(--radius-pill)',
        whiteSpace: 'nowrap',
        ...(variants[variant] || variants.solid),
      }}
      {...rest}
    >
      {children}
    </span>
  );
}

export default Tag;
